import { BaseNavButton, NavigationProps } from './components/BaseNavButton';

export const Navigation = ({
  handleSidebarClose,
  isMobileSideBar,
  items,
}: NavigationProps) => {
  return (
    <nav>
      {items.map(item => (
        <BaseNavButton
          key={item.label}
          item={item}
          isMobileSideBar={isMobileSideBar}
          handleSidebarClose={handleSidebarClose}
        />
      ))}
    </nav>
  );
};
